export default "__VITE_ASSET__D$i6$JAc__"